import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { _Object } from 'utils/interfaces';
import { setLoggedInUser } from '../../../redux/slices/session.slice';
import { Avatar } from 'primereact/avatar';
import { AvatarPlaceholder } from 'assets/images';
import { useLocation } from 'react-router-dom';
import './style.scss'

export default function Header() {
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()

  const { loggedInUser } = useSelector((state: _Object) => state.session)

  useEffect(() => {
    !loggedInUser?.id && dispatch(setLoggedInUser())
  }, [loggedInUser])

  const pathSegments = location?.pathname?.replace('/app/', '')?.split('/')?.filter(Boolean);

  if (pathSegments?.length > 2) {
    pathSegments?.splice(2, 1);
  }

  // const displaySegments = pathSegments?.slice(-2);

  // const displayText = displaySegments?.filter(Boolean)?.join(' ');

  const userProfileImage = loggedInUser?.media?.length > 0 ? loggedInUser?.media[loggedInUser?.media?.length - 1]?.path : AvatarPlaceholder;

  return (
    <>
      <header className='main-header bg-white flex justify-content-between align-items-center border-bottom-1 border-primary-color'>
        <div>
          {/* <h3 className='m-0 capitalize'>
            {displayText}
          </h3> */}

        </div>
        {/* <Link to="/app/profile" className='flex align-items-center gap-2'> */}
        <div className="flex align-items-center gap-2">

          <p className='mr-2 my-0 avatar-name' >Welcome, {loggedInUser?.first_name || ""}</p>
          <Avatar image={userProfileImage} shape="circle" />
        </div>
        {/* </Link> */}
      </header>
    </>
  );
}
